module.exports = __webpack_public_path__ + "static/img/people.99d7a80.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/people.png
// module id = 2O+V
// module chunks = 1